import React, { useEffect } from 'react';
import { Typography } from "@material-ui/core";

// 🔥 CARTAO DE LINK ESTILO WHATSAPP
const AdMetaPreview = ({ image, title, body, sourceUrl, messageUser }) => {
  useEffect(() => {}, [image, title, body, sourceUrl, messageUser]);

  const handleAdClick = () => {
    try {
      if (sourceUrl) window.open(sourceUrl, "_blank");
    } catch (err) { /* nao bloqueia */ }
  };

  // dominio amigavel: tira https:// e www, mostra so o dominio
  const domain = (() => {
    try {
      if (!sourceUrl) return "";
      const u = new URL(sourceUrl.includes("://") ? sourceUrl : "https://" + sourceUrl);
      return u.hostname.replace(/^www\./, "");
    } catch (e) {
      return String(sourceUrl || "").replace(/^https?:\/\//, "").replace(/^www\./, "").split("/")[0];
    }
  })();

  const desc = body || messageUser || "";

  return (
    <div
      onClick={handleAdClick}
      style={{
        minWidth: "250px", maxWidth: "320px", cursor: sourceUrl ? "pointer" : "default",
        border: "1px solid rgba(0,0,0,0.12)", borderRadius: "10px", overflow: "hidden",
        backgroundColor: "rgba(0,0,0,0.04)", display: "flex", flexDirection: "column"
      }}
    >
      {image && (
        <div style={{ width: "100%", maxHeight: 160, overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#e5e5e5" }}>
          <img src={image} alt="" style={{ width: "100%", height: "auto", display: "block", objectFit: "cover" }} />
        </div>
      )}
      <div style={{ padding: "8px 12px 10px" }}>
        <Typography variant="subtitle2" style={{ fontWeight: 700, lineHeight: 1.3, color: "#3b4a54", wordBreak: "break-word" }}>
          {title}
        </Typography>
        {desc && (
          <Typography variant="body2" style={{ marginTop: 2, color: "#667781", lineHeight: 1.35, wordBreak: "break-word" }}>
            {desc}
          </Typography>
        )}
        {domain && (
          <Typography variant="caption" style={{ display: "block", marginTop: 4, color: "#8696a0", fontWeight: 500 }}>
            {domain}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default AdMetaPreview;
